export default __webpack_public_path__ + "static/apple-touch-icon-114x114-3675caa3b3fe29a5efe015687b13bb59.png";